import React, { useState, useEffect, useMemo, useCallback } from "react";
import { getAllLeaves, getLeavesPage } from "../../services/LeaveService.js";
import { Filter } from "lucide-react";
import {StatusBadge} from "../SharedInputs.jsx";

function LeaveList({ onSelectLeave }) {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [activeStatus, setActiveStatus] = useState("pending");
  const [lastCreatedAt, setLastCreatedAt] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const fetchLeaves = useCallback(
    async (reset = false) => {
      setLoading(true);
      try {
        // const data = await getLeavesPage({
        //   limit: 10,
        //   startAfter: reset ? null : lastCreatedAt,
        //   searchText,
        // });
        const data = await getAllLeaves();

        const leaveData = Array.isArray(data) ? data : data?.data || [];

        if (reset) setLeaves(leaveData);
        else setLeaves((prev) => [...prev, ...leaveData]);

        // if (leaveData.length > 0 && leaveData[leaveData.length - 1]?.createdAt) {
        //   setLastCreatedAt(leaveData[leaveData.length - 1].createdAt);
        // }

        // setHasMore(leaveData.length === 10);
      } catch (err) {
        alert("Failed to load leaves");
      } finally {
        setLoading(false);
      }
    },
    [lastCreatedAt, searchText]
  );

  useEffect(() => {
    fetchLeaves(true); // fetch first page
  }, [searchText]);

    // Count leaves by status
    const statusCounts = useMemo(() => {
        const counts = { pending: 0, approved: 0, notApproved: 0, all: leaves.length };

        leaves.forEach((l) => {
            let s = (l.status || "pending").toLowerCase().trim();

            if (s === "not approved" || s === "rejected") {
            s = "notApproved"; // normalize key
            } else if (s === "approved") {
            s = "approved";
            } else {
            s = "pending";
            }

            counts[s] = (counts[s] ?? 0) + 1;
        });

        return counts;
    }, [leaves]);


  const filteredLeaves = useMemo(() => {
    return leaves.filter((l) => {
      const matchStatus = activeStatus === "all" ? true : l.status === activeStatus;
      const matchSearch =
        l.studentName?.toLowerCase().includes(searchText.toLowerCase()) ||
        l.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        l.studentId?.toLowerCase().includes(searchText.toLowerCase());
      return matchStatus && matchSearch;
    });
  }, [leaves, activeStatus, searchText]);

  const chipStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 10,
    padding: "6px 10px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  };
  const labelStyle = { fontSize: 13, color: "#6b7280", fontWeight: 600 };
  const selectStyle = { border: "none", background: "transparent", fontSize: 14, outline: "none", padding: "4px 6px", cursor: "pointer" };

  return (
    <div className="record-list">
      <div style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
        <div style={chipStyle}>
          <Filter size={16} color="#6b7280" />
          <span style={labelStyle}>Status</span>
          <select value={activeStatus} onChange={(e) => setActiveStatus(e.target.value)} style={selectStyle}>
            <option value="all">All ({statusCounts.all})</option>
            <option value="pending">Pending ({statusCounts.pending || 0})</option>
            <option value="approved">Approved ({statusCounts.approved || 0})</option>
            <option value="not approved">Not Approved ({statusCounts.notApproved || 0})</option>
          </select>
        </div>
      </div>

      {loading && leaves.length === 0 ? (
        <p>Loading leave requests...</p>
      ) : (
        <table className="record-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "2px solid #ddd" }}>
              <th style={{ padding: "8px", textAlign: "center" }}>Student ID</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Student</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Email</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Leave Dates</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Reason</th>
              <th style={{ padding: "8px", textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredLeaves.map((leave) => (
              <tr
                key={leave.id}
                onClick={() => onSelectLeave(leave)}
                style={{ cursor: "pointer", borderBottom: "1px solid #eee" }}
              >
                <td style={{ padding: "8px", textAlign: "center" }}>{leave.studentId}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>{leave.studentName}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>{leave.email}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>{leave.startDate} → {leave.endDate}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>{leave.reason}</td>
                <td style={{ padding: "8px", textAlign: "center" }}><StatusBadge status={leave.status} /></td>
              </tr>
            ))}
          </tbody>

        </table>
      )}

      {hasMore && (
        <div style={{ marginTop: "1rem", textAlign: "center" }}>
          <button className="btn btn-secondary" onClick={() => fetchLeaves(false)}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
}

export default LeaveList;
